// extracted by mini-css-extract-plugin
export default {"MultiCheckbox":"multi_MultiCheckbox__ldhkd","checkbox":"multi_checkbox__mpBuu","checked":"multi_checked__zu3FU","circle":"multi_circle__MeNMD","img":"multi_img__Rmupa"};